import React, { Component } from 'react';
import PropTypes from 'prop-types';

import red from '@material-ui/core/colors/red';
import {
  TextField,
  PasswordField,
  Button,
  LoadingIndicator,
  GenderSelect,
  AppBar,
  DatePicker,
  Checkbox,
  Subheader,
  NavigationLink,
} from '../components';
import { ThemeImages, ThemeColors } from '../theme';
import Immutable from 'seamless-immutable';

import ENV from '../../run-config';
import { getTheme2 } from '../app.theme';
import theme from '../app.theme';

class Signup extends Component {

  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      dayOfBirth: null,
      firstName: '',
      lastName: '',
      gender: null,
      company: '',
      phoneNumber: '',
      address: '',
      passwordConfirmation: '',
      jobs: Immutable({}),
    };

    this.setEmail = this.setEmail.bind(this);
    this.setPassword = this.setPassword.bind(this);
    this.setFirstName = this.setFirstName.bind(this);
    this.setLastName = this.setLastName.bind(this);
    this.setDayOfBirth = this.setDayOfBirth.bind(this);
    this.setCompany = this.setCompany.bind(this);
    this.setPhoneNumber = this.setPhoneNumber.bind(this);
    this.setAddress = this.setAddress.bind(this);
    this.toggleJob = this.toggleJob.bind(this);
    this.keyPress = this.keyPress.bind(this);
    this.signup = this.signup.bind(this);
    this.setPasswordConfirmation = this.setPasswordConfirmation.bind(this);

    this.props.loadJobs();
  }

  toggleJob(jobId) {
    let jobs = this.state.jobs;
    if (jobs[jobId]) {
      jobs = jobs.without(jobId);
    } else {
      jobs = jobs.set(jobId, true);
    }

    this.setState({ jobs });
  }

  setEmail(event) {
    this.setState({ email: event.target.value });
  }

  setPassword(event) {
    this.setState({ password: event.target.value });
  }

  setFirstName(event) {
    this.setState({ firstName: event.target.value });
  }

  setFirstName(event) {
    this.setState({ firstName: event.target.value });
  }

  setLastName(event) {
    this.setState({ lastName: event.target.value });
  }

  setDayOfBirth(dayOfBirth) {
    this.setState({ dayOfBirth });
  }

  setCompany(event) {
    this.setState({ company: event.target.value });
  }

  setPhoneNumber(event) {
    this.setState({ phoneNumber: event.target.value });
  }

  setAddress(event) {
    this.setState({ address: event.target.value });
  }

  setPasswordConfirmation(event) {
    this.setState({ passwordConfirmation: event.target.value });
  }


  keyPress(event) {
    if (event.key === 'Enter') {
      this.signup();
      event.preventDefault();
      return false;
    }
    return true;
  }

  validateEmail(email) {
    const re = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
    return re.test(email);
  }


  signup() {
    let error = null;

    if (!ENV.doNotRenderBirthdaySelection && !this.state.dayOfBirth) {
      error = 'Bitte Geburtstag ausfüllen';
    }

    if (!this.state.password || this.state.password.trim() === '') {
      error = 'Bitte Passwort ausfüllen';
    }

    if (this.state.password.length < 6) {
      error = 'Das Passwort muss mindestens 6 Zeichen enthalten';
    }

    if (ENV.usePasswordConfirmationField && (!this.state.passwordConfirmation || this.state.passwordConfirmation.trim() === '')) {
      error = 'Bitte Passwort bestätigen';
    }

    if (ENV.usePasswordConfirmationField && this.state.passwordConfirmation !== this.state.password) {
      error = 'Die eingegebenen Passwörter stimmen nicht überein';
    }

    if (!this.state.email || this.state.email.trim() === '') {
      error = 'Bitte Email ausfüllen';
    } else if (!this.validateEmail(this.state.email)) {
      error = 'E-Mail-Ad­res­se ungültig';
    }

    if (!this.state.lastName || this.state.lastName.trim() === '') {
      error = 'Bitte Nachname ausfüllen';
    }

    if (!this.state.firstName || this.state.firstName.trim() === '') {
      error = 'Bitte Vorname ausfüllen';
    }

    if (this.props.jobs && this.props.jobs.length && !Object.keys(this.state.jobs).length) {
      error = 'Bitte Beruf auswählen';
    }

    if (!error) {
      const { email, firstName, lastName, dayOfBirth, gender, password, company, phoneNumber, address } = this.state;
      const user = { email, firstName, lastName, dayOfBirth, gender, password, company, phoneNumber, address };

      const sanitizedUser = {};

      Object.keys(user).forEach((key) => {
        sanitizedUser[key] = (user[key] && user[key].trim) ? user[key].trim() : user[key];
      });

      sanitizedUser.jobs = Object.keys(this.state.jobs);
      sanitizedUser.confirmPassword = sanitizedUser.password;

      this.props.signup(sanitizedUser);
    } else {
      this.props.showValidationError(error);
    }
  }

  onGenderChanged(gender) {
    this.setState({ gender });
  }

  renderJobSelection() {
    return (
      this.props.jobs.map(job => (
        <Checkbox
          key={job.id}
          checked={this.state.jobs[job.id]}
          onCheck={this.toggleJob.bind(this, job.id)}
          // style={{ textAlign: 'left', paddingLeft: 15 }}
          label={job.name}
        />
      ))
    );
  }

  renderJobSelectionFormGroup() {
    const formGroupStyle = {
      width: '100%',
      marginLeft: 20,
      marginRight: 20,
      // textAlign: 'center',
    };

    if (!this.props.jobs || !this.props.jobs.length) {
      return null;
    }

    return (
      <div style={formGroupStyle}>
        <Subheader style={{ textAlign: 'left' }}>Beruf (Mehrfachauswahl möglich)</Subheader>
        {this.renderJobSelection()}
      </div>
    );
  }

  renderImpressLink() {
    if (ENV.impressUrl) {
      return (
        <a target="_blank" style={{ fontSize: 11, padding: 10 }} href={ENV.impressUrl}>Hiermit stimmst du unseren Nutzungsbedingungen und Datenschutzbestimmungen zu</a>
      );
    }

    return (
      <a style={{ fontSize: 11, padding: 10 }} href="/impressum">Hiermit stimmst du unseren Nutzungsbedingungen und Datenschutzbestimmungen zu</a>
    );
  }

  renderOptionalSignupFields(formGroupStyle) {
    if (ENV.doNotRenderOptionalSignupField) return null;
    return (
      <div>
        <div style={formGroupStyle}>
          <TextField
            placeholder="Betrieb (optional)"
            value={this.state.company}
            onChange={this.setCompany}
            formControlStyle={{ width: '100%' }}
          />
        </div>
        <div style={formGroupStyle}>
          <TextField
            placeholder="Adresse (optional)"
            value={this.state.address}
            onChange={this.setAddress}
          />
        </div>
        <div style={formGroupStyle}>
          <TextField
            placeholder="Telefonnummer (optional)"
            value={this.state.phoneNumber}
            onChange={this.setPhoneNumber}
          />
        </div>
      </div>
    );
  }

  renderBirthdaySelection(formGroupStyle) {
    if (ENV.doNotRenderBirthdaySelection ||
      (this.props.config && this.props.config.signupWithBirthday && this.props.config.signupWithBirthday === 'false')) return null;

    const maxDate = new Date();
    maxDate.setFullYear(maxDate.getFullYear() - 14);
    return (
      <div style={formGroupStyle}>
        <DatePicker
          placeholder="Geburtsdatum auswählen"
          value={this.state.dayOfBirth}
          onChange={this.setDayOfBirth}
          styles={{ marginLeft: 20, paddingRight: 40 }}
        />
      </div>
    );
  }

  renderPasswordConfirmationField(formGroupStyle) {
    if (!ENV.usePasswordConfirmationField) return null;

    return (
      <div style={formGroupStyle}>
        {/* <PasswordField
          required
          placeholder="Passwort wiederholen"
          autoComplete="new-password"
          value={this.state.passwordConfirmation}
          onChange={this.setPasswordConfirmation}
        /> */}
        <PasswordField
          required
          placeholder="Passwort wiederholen"
          type="password"
          autoComplete="new-password"
          value={this.state.passwordConfirmation}
          onChange={this.setPasswordConfirmation}
        />
      </div>
    );
  }

  render() {
    const formGroupStyle = {
      textAlign: 'center',
      margin: '0 20px',
    };

    const containerStyle = {
      width: '300px',
      margin: '0 auto',
      backgroundColor: 'rgba(255, 255, 255, 0.8)',
      marginTop: '20px',
      boxShadow: '-10px 16px 40px rgba(93,87,87,.14)',
    };

    const errorContainerStyle = {
      backgroundColor: red[500],
      textAlign: 'center',
      color: 'white',
    };

    const ErrorMessage = (props) => {
      if (!props.errorMessage) {
        return null;
      }

      return (
        <div style={errorContainerStyle}>
          <span>{props.errorMessage}</span>
        </div>
      );
    };


    const SignupButton = (props) => {
      if (props.loading) {
        return <p><LoadingIndicator style={{ marginTop: 10 }} show /></p>;
      }

      return (<Button
        style={{ marginTop: 10, width: '100%' }}
        labelStyle={{ color: ThemeColors.darkTextOnPrimaryBackground ? 'black' : 'white' }}
        variant="contained"
        fullWidth
        label="Anmelden"
        onClick={this.signup}
        color="primary"
      />);
    };

    return (
      <form style={containerStyle} onKeyPress={this.keyPress} noValidate>
        <div style={{ padding: 20 }}>
          <img src={ThemeImages.logoPath} alt="Logo" style={{ width: '100%' }} />
        </div>
        <AppBar title="Anmeldung" defaultTypography />
        <ErrorMessage {...this.props} />
        <div
          style={{
            ...formGroupStyle,
            marginTop: 10,
          }}
        >
          <TextField
            autoFocus
            required
            placeholder="Vorname"
            value={this.state.firstName}
            onChange={this.setFirstName}
          />
        </div>
        <div style={formGroupStyle}>
          <TextField
            required
            placeholder="Nachname"
            value={this.state.lastName}
            onChange={this.setLastName}
          />
        </div>
        <div style={formGroupStyle}>
          <TextField
            required
            placeholder="E-Mail"
            autoComplete="new-password"
            value={this.state.email}
            onChange={this.setEmail}
          />
        </div>
        <div style={formGroupStyle}>
          <PasswordField
            required
            placeholder="Passwort"
            autoComplete="new-password"
            value={this.state.password}
            onChange={this.setPassword}
          />
        </div>
        {this.renderPasswordConfirmationField(formGroupStyle)}
        {this.renderBirthdaySelection(formGroupStyle)}
        {this.renderJobSelectionFormGroup()}
        {this.renderOptionalSignupFields(formGroupStyle)}
        <div >
          <div
            style={{
              ...formGroupStyle,
              marginTop: 20,
              paddingBottom: 10,
            }}
          >
            {this.renderImpressLink()}
            <br />
            {ENV.forbidCompanySignup ? null : (
              <div>
                <span style={{ marginRight: 10, marginTop: 10 }}>Für Unternehmen:</span>
                <NavigationLink to="benutzerregistrierung">Benutzer registrieren</NavigationLink>
              </div>
            )}
          </div>
          <div>
            <SignupButton {...this.props} />

          </div>
        </div>
      </form>
    );
  }
}

Signup.propTypes = {
  signup: PropTypes.func.isRequired,
};

export default Signup;



// WEBPACK FOOTER //
// ./src/app/signup/signup.js